module.exports = __webpack_public_path__ + "img/提现记录.e54586e4.png";